module.exports = __webpack_public_path__ + "static/media/iphone_mockupyellow.a6321601.png";